import React, {Component} from 'react';

/** @class ArticleContent
  * A component for displaying HTML content
  */
export default class ArticleContent extends Component {
  /** @constructor
    * Constructs a new instance.
    * @prop {string} html - the HTML to display
    */
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  /** @method handleClick
    * Displays the full HTML content in an overlay
    */
  handleClick(event) {
    event.preventDefault();
    if(window.vexpo && window.vexpo.overlay)
      window.vexpo.overlay(this.props);
  }
  /** @method
   * Renders the Article Content component.
   */
  render() {
    var body = {__html: this.props.html}
    return (
      <div className="article" onClick={this.handleClick}>
        <div dangerouslySetInnerHTML={body}/>
        <div className="article-shade"></div>
        <button className="article-more-button" href="#" onClick={this.handleClick}>
          Read More...
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/article-content.js